<!-- 一键求救页面 -->
<template>
  <div class="vcnDeviceList vcnDevicelist_warpd">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <!-- 左侧树 -->
      <div class="section-mian_left tree-line-style">
        <div class="left_title">设备信息</div>
        <div class="device-tab">
          <div v-for="item in calType.column" :key="item.typeId"
            :class="['tab', type.prop == item.prop ? 'active' : '']" @click="handleChange(item)">
            {{ item.label }}
          </div>
        </div>
        <!-- <ioc-tab-group :option="calType" @change="handleChange"></ioc-tab-group> -->
        <div v-if="type.prop === 'tab1'" class="left-type_area">
          <ele-group-tree @getCode="getDeviceWrokGroupCode" @sendData="getDeviceTreeData" :deviceType="checkDevType"
            :paramsType="paramsType" @refresh="initGet()"></ele-group-tree>
        </div>
        <div v-show="type.prop === 'tab2'" class="left-type_area sbar">
          <div class="device-search">
            <el-input placeholder="请输入搜索关键字" prefix-icon="el-icon-search" v-model="searchString" clearable>
            </el-input>
          </div>
          <el-scrollbar class="flex-auto" style="height: calc(100% - 50px)">
            <el-tree ref="tree" class="mb20" node-key="areaDevGroupCode" :data="areaTreeData" :default-expand-all="true"
              :highlight-current="true" :props="defaultProps" :filter-node-method="filterNode"
              @node-click="handleNodeClick">
              <template slot-scope="{ node }">
                <element-tree-line :node="node" :showLabelLine="true" :indent="16" class="tree-line">
                  <span class="custom-tree-node" style="display: block">
                    <i class="el-icon-document"></i>
                    <span style="margin-left: 3px">{{ node.label }}</span>
                  </span>
                </element-tree-line>
              </template>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <!-- 右侧表单 -->
      <div class="section-mian_right">
        <!-- 主机设备列表 -->
        <div class="nvr-table">
          <!-- 头部按钮 -->
          <div class="section-mian__toolbar flex-row">
            <el-button type="primary" class="iss-operation-button" icon="iconfont icon-iconfontfanhui" @click="
              () => {
                $router.push('/cameralist/devicelist');
              }
            ">返回</el-button>
          </div>
          <!-- 表格部分 -->
          <div class="section-main_table">
            <ioc-table ref="devTab" :data="deviceData" :option="deviceOption" :page="devicePage"
              @search-change="handleSearchChange" @search-reset="resetForm" @current-change="selectPage"
              @selection-change="selectionChange" @size-change="changeSize">
              <!-- 定制操作栏按钮 -->
              <template slot="menu" slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="修改" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" v-auth="'/cameralist/devicelist:update'" @click="update(scope.row)"
                    icon="iconfont icon-xiugai"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="详情" placement="top" popper-class="tooltip-draw">
                  <el-button type="text" class="iconfont icon-Detail" @click="showDetail(scope.row)"></el-button>
                </el-tooltip>
              </template>
            </ioc-table>
          </div>
        </div>
      </div>
    </div>
    <!-- add+update设备数据弹框  -->
    <!-- <el-dialog
      :title="dialogTitle"
      :close-on-click-modal="false"
      v-dialogDrag
      :visible.sync="editDevDialog"
      width="66%"
      :center="true"
    >
      <edit-dev :key="key" ref="editDev"></edit-dev>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="diaLoading" @click="editDlgPre">{{
          diaLoading ? "保存中..." : "保 存"
        }}</el-button>
        <el-button @click="editDevDialog = false">{{
          diaLoading ? "保存中..." : "取 消"
        }}</el-button>
      </span>
    </el-dialog> -->

    <AppPanel class="app-panel" :width="800" :isExpand="editDevDialog" @cancel="editDevDialog = false"
      :title="dialogTitle">
      <edit-dev :key="key" ref="editDev"></edit-dev>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDevDialog = false" type="info">{{
          diaLoading? "保存中...": "取 消"
        }}</el-button>
        <el-button type="primary" :loading="diaLoading" @click="editDlgPre">{{
          diaLoading? "保存中...": "保 存"
        }}</el-button>
      </span>
    </AppPanel>

  </div>
</template>
<script>
import ElementTreeLine from "element-tree-line";
import { api } from "../api/index";
import { Dic, Dates, Cache } from "$utils";
import utils from "@src/common/utils";
import i18n from "@src/common/lib/i18n";
import { tableOption } from "../const/help";
import eleGroupTree from "../components/equipmentGroupTree";
import editDev from "@src/modules/deviceAccess/components/VCN/touchDia";
import AppPanel from "@src/components/business/app-panel/index.vue";
export default {
  components: {
    AppPanel,
    editDev,
    eleGroupTree,
    ElementTreeLine
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    return {
      searchString: "",
      diaLoading: false,
      key: 0,
      dialogTitle: "",
      editDevDialog: false,
      delConfirm: false,
      dialogVisible: false,
      // 存储列表数据获取方式：1、通过左侧树；2、通过搜索条件；删除时用同样的方式刷新列表数据
      getDevListType: "",
      // 选中设备ID集合
      selDev: [],
      // 查询字段
      queryForm: {},
      // 系统id
      systemId: 200000024,
      platID: "",
      factoryId: "",
      systemName: "",
      deviceType: "",
      // 树的props
      treeProps: {
        label: "thirdDeviceName",
        children: "subDeviceList"
      },
      // 设备树的数据
      frame: [],
      // 树的节点值
      treeKey: "-1",
      // 设备ID
      deviceId: "",
      // 分页属性设置
      devicePage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      cameraPage: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      deviceData: [],
      cameraData: [],
      videoStreamData: [],
      deviceOption: tableOption(this),
      level: "",
      areaCode: "",
      cacheRouterInfo: {},
      areaTreeData: [],
      calType: {
        column: [
          {
            label: this.$t("cameraList.label.deviceSet"),
            prop: "tab1"
          },
          {
            label: this.$t("cameraList.label.areaSets"),
            prop: "tab2"
          }
        ]
      },
      type: {
        label: this.$t("cameraList.label.deviceSet"),
        prop: "tab1"
      },
      checkDevType: "",
      paramsType: "",
      defaultProps: {
        children: "areaChildren",
        label: "areaDevGroupName"
      },
      areaDevGroupCode: "", //区域id
      deviceWorkGroupCode: "" //设备组id
    };
  },
  created() {
    this.setCheckDevType();
    if (this.$route.query.device) {
      this.cacheRouterInfo = this.$route.query.device;
    }
    this.type = this.calType.column[0];
    this.systemId = this.cacheRouterInfo.systemId;
    this.systemName = this.cacheRouterInfo.systemName;
    this.platID = this.cacheRouterInfo.platID;
    this.factoryId = this.cacheRouterInfo.factoryId;
    this.deviceType = this.cacheRouterInfo.deviceType;
  },
  mounted() {
    this.initGet();
  },
  methods: {
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.areaDevGroupName.indexOf(value) !== -1;
    },
    handleNodeClick(data) {
      this.deviceWorkGroupCode = "";
      this.areaDevGroupCode = data.areaDevGroupCode;
      this.getDevList();
    },
    setCheckDevType() {
      if (this.$route.query.device.deviceTypeId) {
        this.checkDevType = this.$route.query.device.deviceTypeId;
        Cache.put("deviceTypeId", this.$route.query.device.deviceTypeId);
        Cache.put("deviceType", this.$route.query.device.deviceType);
        this.paramsType = this.$route.query.device.deviceType;
      } else {
        this.checkDevType = Cache.get("deviceTypeId");
        this.paramsType = Cache.get("deviceType");
      }
    },
    initGet() {
      this.getAreaTree();
      this.getDevList();
    },

    // 获取设备组tree CallBack
    getDeviceTreeData(data) {
      // console.log(data)
      // this.deviceTreeData = data;
    },

    // 设备组点击callback
    getDeviceWrokGroupCode(code) {
      this.areaDevGroupCode = "";
      this.deviceWorkGroupCode = code;
      this.getDevList();
    },
    // 切换tab 回调
    handleChange(column) {
      this.type = column;
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = 10;
      // this.initGet();
      this.$nextTick(() => {
        this.$refs.devTab.reset();
      });
    },
    // 设备组tree
    getAreaTree() {
      this.$fetch(api.deviceMan.queryAssociationalDeviceTree).then((res) => {
        this.areaTreeData = res.returnObj;
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(this.areaTreeData[0]);
        });
      });
    },
    // 新增/编辑保存
    editDlgPre() {
      let data = {};
      data = this.$refs.editDev.devInData;
      this.$refs.editDev.validateForm().then((valid) => {
        if (valid) {
          let params = {
            buildingCode: data.isIndoor != 1 ? "" : data.buildingCode, //所属楼栋
            abscissa: data.isIndoor != 1 ? "" : data.abscissa,
            ordinate: data.isIndoor != 1 ? "" : data.ordinate,
            height: data.isIndoor != 1 ? "" : data.height,
            width: data.isIndoor != 1 ? "" : data.width,
            isIndoor: data.isIndoor,
            latitude: data.isIndoor != 1 ? data.latitude : "",
            longitude: data.isIndoor != 1 ? data.longitude : "",
            status: data.status, //设备状态
            systemId: this.systemId,
            thirdDeviceId: data.thirdDeviceId, //设备第三方id
            thirdDeviceName: data.thirdDeviceName, //设备名称
            thirdDeviceDesc: data.thirdDeviceDesc, //设备描述
            // 自定义数据
            deviceExtendInfoMap: {
              zAlarmTime: data.zAlarmTime,
              zBattery: data.zBattery,
              zBusinessName: data.zBusinessName,
              zDeviceType: data.zDeviceType,
              zFmeter: data.zFmeter,
              zGVersion: data.zGVersion,
              zGrade: data.zGrade,
              zHeartTime: data.zHeartTime,
              zIDinteger: data.zIDinteger,
              zJmeter: data.zJmeter,
              zLinkNum: data.zLinkNum,
              zLinkTime: data.zLinkTime,
              zRange: data.zRange,
              zSVersion: data.zSVersion,
              zSetHeartTime: data.zSetHeartTime,
              zSetLinkNum: data.zSetLinkNum,
              zSetLinkTime: data.zSetLinkTime,
              zSetStress: data.zSetStress,
              zSetTime: data.zSetTime,
              zSmeter: data.zSmeter,
              zSnr: data.zSnr,
              zStates: data.zStates
            }
          };
          let url = api.updateSosDevice;
          params.deviceID = data.deviceId;
          this.diaLoading = true;
          this.$fetch(url, params).then((res) => {
            setTimeout(() => {
              this.diaLoading = false;
            }, 500);
            if (res.success) {
              this.$message.success(res.msgContent);
              this.editDevDialog = false;
              this.getDevList();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 请求数据列表数据
    requestList() {
      const param = Object.assign(this.queryForm, {
        pageSize: this.devicePage.pageSize,
        page: this.devicePage.currentPage,
        // // systemId: this.systemId,
        deviceType: "31" || his.paramsType,
        deviceWorkGroupCode: this.deviceWorkGroupCode,
        area: this.areaDevGroupCode
        // deviceId: "",
        // deviceName: "",
        // isMap: "",
        // parentCodes: "",
        // parkId: "200000001",
        // status: ""
      });
      // this.$fetch(api.querySosList, param).then((res) => {
      this.$fetch(api.deviceMan.getDeviceListByPage, param).then((res) => {
        if (res.success && res.returnObj.list) {
          this.deviceData = res.returnObj.list;
          this.devicePage.total = res.returnObj.total;
        } else {
          this.$message.error(res.msgContent);
        }
      });
    },
    // 根据查询条件查询列表
    queryDev() {
      this.devicePage.currentPage = 1;
      this.getDevListType = 1;
      this.requestList();
    },
    // 根据树查询设备列表
    getDevList() {
      this.devicePage.currentPage = 1;
      this.getDevListType = 2;
      this.requestList();
    },

    //查看详情
    showDetail(row) {
      this.$refs.devTab.rowView(row);
    },
    // 重置搜索
    resetForm() {
      this.devicePage.pageSize = utils.Cache.get("CURRENT_PAGESIZE") || 10;
      this.devicePage.pageNo = 1;
      this.getDevListType = 2;
      this.treeKey = "";
      this.requestList();
      this.devicePage.currentPage = 1;
    },

    // 当选择项发生变化时会触发该事件
    selectionChange(selections) {
      let myAry = [];
      selections.map((item) => {
        myAry.push(item.deviceID);
      });
      this.selDev = myAry;
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.devicePage.currentPage = val;
      if (this.getDevListType == 1) {
        this.getDevListType = 1;
        this.requestList();
      } else if (this.getDevListType == 2) {
        this.getDevListType = 2;
        this.requestList();
      }
    },
    // 修改每页数据数量
    changeSize(val) {
      this.devicePage.currentPage = 1;
      this.devicePage.pageSize = val;
      if (this.getDevListType == 1) {
        this.queryDev();
      } else if (this.getDevListType == 2) {
        this.getDevList();
      }
    },
    // 编辑按钮
    update(row) {
      this.rowInfo = { ...row };
      this.editDevDialog = true;
      this.dialogTitle = "编辑设备";
      this.$nextTick(() => {
        this.$refs.editDev.devInData = Object.assign(
          row,
          row.deviceExtendInfoMap
        );
        this.$refs.editDev.selectChange(row.isIndoor);
      });
    },
    handleSearchChange(param) {
      this.queryForm = param;
      this.devicePage.currentPage = 1;
      this.requestList();
    }
  }
};
</script>
<style lang="scss" scoped>
// .section-mian_left {
//   width: 300px;
// }
.vcnDeviceList {
  width: 100%;
  height: 100%;

  .section-main__warp {
    margin: 0 !important;
  }

  .upload-demo {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
@import "~@src/common/assets/style/mixin";

.vcnDeviceList {
  .left-type_area {
    height: calc(100% - 100px);
    position: relative;
    flex: 1;
    overflow: hidden;
    @include set_theme_color(background-color, left-menu-bg-color);
  }
}

.vcnDevicelist_warpd {
  .el-table__fixed-right-patch {
    display: none;
  }

  .left_title {
    border-left: 4px solid #407aee;
    padding-left: 8px;
    margin: 16px;
  }

  .device-tab {
    display: flex;
    margin: 0 16px 0px 16px;

    .tab {
      color: #9aa6c1;
      flex: 1;
      text-align: center;
      padding-bottom: 10px;
      border-bottom: 1px solid #707070;

      &:hover {
        color: #fff;
        cursor: pointer;
      }
    }

    .active {
      color: #fff;
      border-color: #407aee;
    }
  }

  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;

    .el-input {
      width: 100%;
    }
  }

  .devDtaildata {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .nvr-table {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  // .tree-content {
  //   width: fit-content;
  //   min-width: 100%;
  //   .el-tree-node__label {
  //     display: inline-block;
  //     max-width: 80%;
  //     text-overflow: ellipsis;
  //     overflow: hidden;
  //     white-space: nowrap;
  //   }
  //   .el-tree-node__content {
  //     height: 40px;
  //     line-height: 40px;
  //     &:hover {
  //       background: rgb(45, 73, 118);
  //     }
  //     .custom-tree-node {
  //       width: 100%;
  //       height: 40px;
  //       line-height: 40px;
  //       display: flex;
  //       .tree-label {
  //         width: 150px;
  //         overflow: hidden;
  //         text-overflow: ellipsis;
  //         white-space: nowrap;
  //       }
  //       .area-operator {
  //         display: inline-block;
  //         margin-left: 10px;
  //       }
  //     }
  //     &:before {
  //       margin-top: -26px !important;
  //     }
  //   }
  // }
  .scroll-bar-view {
    // @include set_theme_color(background-color, top-menu-bg-color);
    height: calc(100% - 0px);

    .el-scrollbar__wrap {

      // height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
}

.el-select {
  width: 100%;
}
</style>
